module.exports = __webpack_public_path__ + "img/background_medio_web-1070.f17aabdc.webp";